import eventBus from '@/event_bus'

export function removeElementById (id) {
    const dom = document.getElementById(id)

    if (dom !== null) {
        dom.parentNode.removeChild(dom)
    }
}

export function getStyle (dom, attr) {
    if (dom.currentStyle) {
        return dom.currentStyle[attr]
    } else {
        return getComputedStyle(dom, false)[attr]
    }
}

export function scrollTo (dom, x = 0, y = 0) {
    if (!dom) {
        return
    }
    if (x === 'scrollWidth') {
        x = dom.scrollWidth
    }
    if (y === 'scrollHeight') {
        y = dom.scrollHeight
    }
    dom.scrollTo(x, y)
}

/**
 * 根据 img 的 src 判断图片是否加载完成
 * @param { String } url
 */
export async function imgSrcLoaded (url) {
    return new Promise(resolve => {
        const img = new Image()
        img.onload = () => {
            resolve(url)
        }
        img.src = url
    })
}

let PAGE_HIDDEN = ''
let visibilityChange = ''

// Opera 12.10 and Firefox 18 and later support
if (typeof document.hidden !== 'undefined') {
    PAGE_HIDDEN = 'hidden'
    visibilityChange = 'visibilitychange'
} else if (typeof document.msHidden !== 'undefined') {
    PAGE_HIDDEN = 'msHidden'
    visibilityChange = 'msvisibilitychange'
} else if (typeof document.webkitHidden !== 'undefined') {
    PAGE_HIDDEN = 'webkitHidden'
    visibilityChange = 'webkitvisibilitychange'
}

const isSupportVisibilityChange = Boolean(PAGE_HIDDEN && visibilityChange)

export const pageVisibility = {
    PAGE_HIDDEN,
    visibilityChange,
    isSupportVisibilityChange
}

/**
 * 判断光标是否在编辑区域的开头或结尾位置
 * https://stackoverflow.com/a/7478420
 * @param { Element } el
 * @returns { Object }
 * @example
 *
 * return {
 *      atStart: Boolean,
 *      atEnd: Boolean
 * }
 */
export function getSelectionTextInfo (el) {
    let atStart = false
    let atEnd = false
    let selRange
    let testRange
    if (window.getSelection) {
        const sel = window.getSelection()
        if (sel.rangeCount) {
            selRange = sel.getRangeAt(0)
            testRange = selRange.cloneRange()

            testRange.selectNodeContents(el)
            testRange.setEnd(selRange.startContainer, selRange.startOffset)
            atStart = (testRange.toString() === '')

            testRange.selectNodeContents(el)
            testRange.setStart(selRange.endContainer, selRange.endOffset)
            atEnd = (testRange.toString() === '')
        }
    } else if (document.selection && document.selection.type !== 'Control') {
        selRange = document.selection.createRange()
        testRange = selRange.duplicate()

        testRange.moveToElementText(el)
        testRange.setEndPoint('EndToStart', selRange)
        atStart = (testRange.text === '')

        testRange.moveToElementText(el)
        testRange.setEndPoint('StartToEnd', selRange)
        atEnd = (testRange.text === '')
    }

    return { atStart, atEnd }
}

export function setPageTitle (title) {
    document.title = title
}

/**
 * 获取聊天框距离视口顶部的距离（用于 PC 端，因为移动端是 0）
 * @returns { Number }
 */
export function getAppOffsetTop () {
    if (eventBus.isMobile) {
        return 0
    }
    const $app = document.getElementById('app')
    const { top } = $app.getBoundingClientRect()
    return top
}

export function isSupportScrollBehavior () {
    return 'scrollBehavior' in document.documentElement.style
}

export function hasClass (el, className) {
    return el.classList.contains(className)
}

// 计算元素相对于body的偏移量
export function offsetByBody (obj, direction) {
    //将top,left首字母大写,并拼接成offsetTop,offsetLeft
    let offsetDir = 'offset'+ direction[0].toUpperCase() + direction.substring(1)
    let realNum = obj[offsetDir]
    let positionParent = obj.offsetParent //获取上一级定位元素对象
    while(positionParent !== null) {
        realNum += positionParent[offsetDir]
        positionParent = positionParent.offsetParent
    }
    return realNum
}

// 停止所有的音频
export function stopAllAudio (reset = true) {
    let allAudio = document.querySelectorAll('audio')
    if(allAudio && allAudio.length > 0) {
        for(let i = 0; i < allAudio.length; i++) {
            allAudio[i].pause()
            if (reset) { // 是否重置进度
                allAudio[i].currentTime = 0
            }
        }
    }
}